import Component from "./component"
import Header from "./header"
import Context from "./context"

export default {
  Component,
  Context,
  Header,
}
